import React from 'react';
import { useTranslation } from 'react-i18next';
import './PartnersLogoBar.css';
import { partnersData } from '../../utils/partnersData';

const PartnersLogoBar: React.FC = () => {
  const { t } = useTranslation();
  const duplicatedPartners = [...partnersData, ...partnersData];

  return (
    <section className="partners-logo-bar">
      <div className="partners-container">
        <div className="partners-header">
          <h3 className="partners-title">{t('partners.title')}</h3>
          <div className="partners-divider"></div>
        </div>

        <div className="logo-scroll-container">
          <div className="logo-scroll-track">
            {duplicatedPartners.map((partner, index) => (
              <div
                key={`${partner.id}-${index}`}
                className={`logo-item ${partner.name === 'Dafo Vehicle Fire Suppression' ? 'logo-item-dafo' : ''}`}
              >
                <img src={partner.logo} alt={partner.name} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default PartnersLogoBar;
